var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"font-weight-bold mb-2"},[_vm._v(_vm._s(_vm.file.name))]),(_vm.base64Image)?_c('v-img',{attrs:{"src":_vm.base64Image,"width":_vm.size,"height":_vm.size}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }